
const InfoTab = require('app/product/show/InfoTab');
const PriceTab = require('app/product/show/PriceTab');
const LogsTab = require('app/product/show/LogsTab');
const StatTab = require('app/product/show/StatTab');
const SimilarTab = require('app/product/show/SimilarTab');

class ShowView {
    defaultOptions() {
        return {
            'activeTab': 'info',
            'selector': '.view-product-show',
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);


        this.onTabChange = this.onTabChange.bind(this);

        this.$container = $(this.settings.selector);
        if(this.$container.length <= 0){
            window.notify("Can't find container view with selector " + this.settings.selector,'danger');
        }


        this.initialize();
    }

    initialize() {
        var self = this;

        $('button[data-bs-toggle="tab"]',this.$container)
        .on('shown.bs.tab',this.onTabChange);

        this.loadTab(this.settings.activeTab);
    }

    onTabChange(event){

        let $shownTabBtn = $(event.target);
        let $previousShownTabBtn = $(event.relatedTarget);

        let shownTab = $shownTabBtn.data('tab');
        let previousShownTab = $previousShownTabBtn.data('tab');

        this.clearTab(previousShownTab);
        this.loadTab(shownTab);
    }

    clearTab(tab){
        let $tabBody = $('.'+tab+'-body',this.$container);

        $tabBody.html('');
    }
    
    loadTab(tab){
        let $tabBody = $('.'+tab+'-body',this.$container);

        $tabBody.html('')
        .append(window.App.generateLoader());

        window.setUrlParameter('tab',tab);

        switch(tab){
            case 'info':
                let infoTab = new InfoTab({
                    'product': this.settings.product,
                    '$container': $tabBody
                });
            break;
            case 'prices':
                let priceTab = new PriceTab({
                    'product': this.settings.product,
                    '$container': $tabBody
                });
            break;
            case 'stat':
                let statTab = new StatTab({
                    'product': this.settings.product,
                    '$container': $tabBody
                });
            break;
            case 'similar':
                let similarTab = new SimilarTab({
                    'product': this.settings.product,
                    '$container': $tabBody
                });
            break;
            case 'logs':
                let logsTab = new LogsTab({
                    'product': this.settings.product,
                    '$container': $tabBody
                });

            break;
        }
    }

}

module.exports = ShowView;

